<template>
  <TheSideMenu
    :data-user-app="dataUserApp"
    @logout="handleLogoutClick"
    @open-notification-erp="emitOpenNotificationShowAlert"
  />

  <f7-view
    key="view-main"
    main
    url="/"
    :stack-pages="true"
  >
    <PCInformationBar />
  </f7-view>
</template>

<script setup>
// @ts-check
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useAppConfigStore } from '@/js/stores/appConfig';
import { useResetStore } from '@/js/utils/resetStore';
import eventBus from '@/js/event-bus';
import { f7 } from 'framework7-vue';
import { resetParams } from '@erpagroapp/params';
import { resetLocalSettings } from '@erpagroapp/settings';

import TheSideMenu from '@/components/TheSideMenu.vue';
import PCInformationBar from '@/components/common/PCInformationBar.vue';

const {
  loginNeeded,
  accessTokenERP,
  userLoginData,
} = storeToRefs(useAppConfigStore());

const dataUserApp = computed(/** @type {{ UserName: string; Role: string; } | null} */ () => (userLoginData.value ? {
  UserName: userLoginData.value.UserName,
  Role: 'Usuario',
} : null));

/**
 * Handles the event for opening ERP notifications.
 * @returns {void}
 */
function emitOpenNotificationShowAlert() {
  eventBus.emit('open-notification-show-alert');
}

/**
 * Handles user logout event. Performs necessary actions upon logout.
 * @returns {Promise<void>} A promise that resolves when the logout is completed.
 */
async function handleLogoutClick() {
  const resetStore = await useResetStore();
  resetStore.all();

  resetParams();
  resetLocalSettings();

  f7.views.main.router.clearPreviousHistory();

  loginNeeded.value = true;
  accessTokenERP.value = null;
}
</script>
